import { myVanToast } from "@/plugins/vant.js";
import i18n from "@/plugins/i18n.js";

export const copyText = (item) => {
    var input = document.createElement("textarea"); // js创建一个input输入框
    input.value = item; // 将需要复制的文本赋值到创建的input输入框中
    document.body.appendChild(input); // 将输入框暂时创建到实例里面
    input.select(); // 选中输入框中的内容
    document.execCommand("Copy"); // 执行复制操作
    document.body.removeChild(input); // 最后删除实例中临时创建的input输入框，完成复制操作
    myVanToast({
        type: "success",
        message: i18n.global.t("public.copy_success"),
    });
};
export const addCommasToNumber = (number) => {
    if (number >= 0) {
        // 将数字转换为字符串
        let str = String(number);

        // 判断是否为负数
        let isNegative = false;
        if (str.startsWith("-")) {
            isNegative = true;
            str = str.substring(1); // 去掉负号
        }

        // 分割整数部分和小数部分
        const parts = str.split(".");
        let integerPart = parts[0];
        const decimalPart = parts[1] || "";

        // 给整数部分添加逗号
        let result = "";
        while (integerPart.length > 3) {
            result = "," + integerPart.slice(-3) + result;
            integerPart = integerPart.slice(0, -3);
        }
        result = integerPart + result;

        // 添加小数部分（如果有）
        if (decimalPart.length > 0) {
            result += "." + decimalPart;
        }

        // 添加负号（如果是负数）
        if (isNegative) {
            result = "-" + result;
        }
        return result;
    }
    return 0;
};
